import { administrationModule, attestBookModule, booksModule, reportModule } from "./shared";

export const cplrData = [
    {
      iconComponent: 'so-icon',
      title: 'СПИСЪК-ОБРАЗЕЦ',
      details: [
        {
          text: 'Актуализиране и изпращане на данни от и към НЕИСПУО винаги, когато е необходимо'
        },
        {
          text: 'Въвеждане на данните за списък-образец № 3 в интуитивна електронна среда'
        },
        {
          text: 'Преглеждане на архив на списък-образците от предходни години, ако са били създадени с модула'
        },
      ]
    },  
    {
      iconComponent: 'dnevnik-icon',
      title: 'ЕЛЕКТРОНЕН<br>ДНЕВНИК',
      details: [
        {
          text: 'Администриране на целия процес по водене на електронните дневници съгласно Наредба № 8 от 11.08.2016 г.'
        },
        {
          text: 'Двустранна интеграция с НЕИСПУО'
        },
        {
          text: 'Генериране на различни справки, свързани с децата и учениците, архив от минали години и генериране на PDF файл'
        }
      ]
    },
    reportModule,
    booksModule,
    attestBookModule,
    {
      iconComponent: 'calendar-icon',
      title: 'КАЛЕНДАР НА<br>СЪБИТИЯТА',
      details: [
        {
          text: 'Въвеждане на информация за различни събития'
        },
        {
          text: 'Достъп на родители и ученици'
        },
        {
          text: 'Справки по вид събитие'
        },
      ]
    },
    {
      iconComponent: 'messages-icon',
      title: 'СЪОБЩЕНИЯ',
      details: [
        {
          text: 'Вътрешна мрежа за обмен на съобщения между учители, ученици, родители и администрация'
        },
        {
          text: 'Създаване на потребителски групи'
        },
        {
          text: 'Препращане на съобщения'
        },
      ]
    },
    administrationModule
  ]
  